import React from 'react';
import styled from 'styled-components';

const AboutContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: right;
  padding-top: 1.5rem;
`;

const Subtitle = styled.h2`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 1.4rem;
  font-weight: 600;
  margin: ${({ theme }) => theme.spacing.md} 0
    ${({ theme }) => theme.spacing.sm};
`;

const Paragraph = styled.p`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

const CheckList = styled.ul`
  list-style: none;
  padding: 0;
  margin: ${({ theme }) => theme.spacing.sm} 0;
`;

const CheckItem = styled.li`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 0.3rem;
  display: flex;
  align-items: center;

  &::before {
    content: '✅';
    margin-left: 0.5rem;
  }
`;

const About = () => {
  return (
    <AboutContainer>
      <Subtitle>מי אנחנו?</Subtitle>
      <Paragraph>
        שמי חיים בן חיים, ואני מדריך, יועץ ומתכנן טיולים במזרח הרחוק המתמחה
        בתאילנד, וייטנאם וקמבודיה. מאז ומתמיד אהבתי לטייל, לחקור תרבויות חדשות
        ולגלות מקומות קסומים, ובעיקר - לשתף אחרים בחוויותיי. אחרי 20 שנות שירות
        כקצין בצה"ל, החלטתי להפוך את התשוקה שלי לדרך חיים. אני בוגר תואר ראשון
        במנהל עסקים (בהצטיינות) ובוגר קורס מדריכי טיולים לחו"ל של אוניברסיטת
        חיפה - בית הספר לתיירות.
      </Paragraph>

      <Paragraph>
        נולדתי וגדלתי במשפחה חרדית, ומשם צמחתי עם שילוב של חינוך לערכים ולמסורת
        יחד עם אהבה לעולם הגדול. מתוך הרקע הייחודי שלי, הקמתי מוקד ידע והדרכה
        שנועד להנגיש את המזרח הרחוק למגוון קהלים - כולל משפחות, זוגות, תרמילאים
        ומטיילים שומרי מסורת. בשנים האחרונות אני מטייל רבות במזרח, חוקר אזורים
        פחות מוכרים ומסייע למטיילים בתכנון חוויות ייחודיות ובלתי נשכחות.
      </Paragraph>

      <Paragraph>
        שמי עידו יפת, נשוי לאור ואבא לשתי בנות מקסימות. המזרח הרחוק תמיד היה חלק
        מהחיים שלי - טיילתי לאורכו ולרוחבו, הן כתרמילאי צעיר, הן כזוג עם אשתי,
        ולאחר מכן כמשפחה עם שתי בנותינו. טיילנו שוב ושוב בתאילנד, חווינו את הקסם
        של קמבודיה, ולמדנו איך להפוך כל טיול להרפתקה שתשאיר זיכרונות מדהימים לכל
        החיים.
      </Paragraph>

      <Paragraph>
        לאורך השנים הבנתי כמה חשוב לתכנן טיול נכון - כזה שמתאים בדיוק לאופי
        המטיילים, בין אם זה משפחות, תרמילאים או זוגות. יחד עם חיים, החלטנו לקחת
        את הידע והניסיון שצברנו ולהקים פלטפורמה שתהפוך את תכנון הטיול לקל, נגיש
        ומדויק לכל מי שחולם לחקור את המזרח הרחוק.
      </Paragraph>

      <Subtitle>למה הקמנו את "מזרח ללא גבולות"?</Subtitle>
      <Paragraph>
        המזרח עבורנו הוא לא רק יעד - הוא חוויה. אווירה קסומה, תרבות ייחודית, טבע
        עוצר נשימה ואנשים חמים. כדי להנגיש את כל זה למטיילים, יזמנו והקמנו את
        "מזרח ללא גבולות" - בית דיגיטלי למטיילים במזרח הרחוק.
      </Paragraph>

      <Subtitle>באתר תמצאו:</Subtitle>
      <CheckList>
        <CheckItem>מידע מקיף על היעדים הכי חמים במזרח הרחוק</CheckItem>
        <CheckItem>
          מסלולים מומלצים למטיילים - משפחות, תרמילאים וזוגות
        </CheckItem>
        <CheckItem>ליווי אישי ותכנון טיולים בהתאמה אישית</CheckItem>
      </CheckList>

      <Paragraph>
        אנחנו כאן כדי לעזור לכם לחוות את המזרח בצורה המושלמת - חווייתית, מרתקת
        ובלתי נשכחת.
      </Paragraph>
    </AboutContainer>
  );
};

export default About;
